<div #dynamicChoiceItemContainer>

</div>